<div #dynamicChoiceItemContainer>

</div>